import React from 'react'

export default () => (
  <svg width="13px" height="12px" viewBox="0 0 13 12"
    version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink"
  >
    <g id="7-9" stroke="none" strokeWidth="1"
      fill="none" fillRule="evenodd"
    >
      <g id="RM---answering-autogen-question" transform="translate(-342.000000, -1042.000000)">
        <g id="writing-explanation" transform="translate(262.000000, 1028.000000)">
          <g id="Q&amp;A">
            <rect id="Rectangle" stroke="#9B9B9B" strokeWidth="0.5"
              fill="#F2F2F2" x="0.25" y="0.25"
              width="697.5" height="43.5"
            />
            <text id="Trends" fontFamily="OpenSans, Open Sans" fontSize="14"
              fontWeight="normal" fill="#56565A"
            >
              <tspan x="15.2846715" y="25">Trends</tspan>
            </text>
          </g>
          <g id="question-circle" transform="translate(80.499270, 14.000000)" stroke="#808284"
            strokeWidth="0.75"
          >
            <path d="M4.58540146,4.5 C4.58554989,3.7372146 5.16899761,3.09600506 5.9412888,3.00987868 C6.71357998,2.9237523 7.42875412,3.42013873 7.60329812,4.16344233 C7.77784213,4.90674593 7.35616696,5.66023818 6.62335766,5.9145 C6.31787217,6.02049382 6.11369875,6.30401845 6.11386861,6.622 L6.11386861,7.125" id="Path" strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path d="M6.11386861,8.625 C6.00834998,8.625 5.92281022,8.70894661 5.92281022,8.8125 C5.92281022,8.91605339 6.00834998,9 6.11386861,9 C6.21938725,9 6.30492701,8.91605339 6.30492701,8.8125 C6.30492701,8.70894661 6.21938725,8.625 6.11386861,8.625 L6.11386861,8.625" id="Path" strokeLinecap="round"
              strokeLinejoin="round"
            />
            <ellipse id="Oval" cx="6.11386861" cy="6"
              rx="5.73175182" ry="5.625"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)
